import { mapActions, mapState } from 'pinia';
import { useLocationsStore } from '@@/stores/Locations';

export default {
  data() {
    return {
      keepCompareOnReset: false,
    };
  },

  computed: {
    ...mapState(useLocationsStore, ['isCompareSeasonPasses']),

    canShowSelectFavoriteListDialog() {
      return this.isCompareSeasonPasses;
    },
  },

  methods: {
    ...mapActions(useLocationsStore, ['resetLocations']),
  },
};
